<div class="gd-confirm-dialog__wrapper gd-global-material-dialog-padding" [dir]="dir$ | async">
<h2 class="mat-h2 gd-confirm-dialog__title">{{ title }}</h2>
<p class="gd-confirm-dialog__message" [innerHTML]="message"></p>

<div class="tw-flex tw-flex-row tw-justify-around tw-items-stretch tw-gap-6">
  <button class="gd-confirm-dialog__confirm-button" type="button" mat-button color="primary" (click)="dialogRef.close(true)" data-cy="gd-confirm-yes">{{confirmButton}}</button>
  <button type="button" mat-button color="primary" (click)="dialogRef.close(false)" data-cy="gd-confirm-no">{{closeButton}}</button>
</div>
</div>
